module.exports = __webpack_public_path__ + "img/heart_process.9865737e.png";